import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export interface SubmittedJob {
  projectName: string;
  jobReference: string;
}

export interface UseJobSubmittedModalResult {
  submittedJob: SubmittedJob | null;
  handleClose: () => void;
}

/**
 * Reads `location.state.submittedJob` once on mount, then clears it via a
 * replace-navigation so a refresh does not re-show the modal (AC 10). The
 * generate-accuracy form navigates away before the modal can render, so
 * ownership — and the router-state hand-off — belongs here rather than in the
 * form.
 */
export const useJobSubmittedModal = (): UseJobSubmittedModalResult => {
  const location = useLocation();
  const navigate = useNavigate();

  const [submittedJob, setSubmittedJob] = useState<SubmittedJob | null>(null);

  useEffect(() => {
    const state = location.state as { submittedJob?: SubmittedJob } | null;
    if (state?.submittedJob) {
      setSubmittedJob(state.submittedJob);
      navigate(location.pathname, { replace: true, state: null });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => setSubmittedJob(null);

  return { submittedJob, handleClose };
};
